import React from "react";
import { welcomeData } from "../../utils/WelcomeData";

const GOLD = "#ffc000";
const PRIMARY = "#000c66";
const IMG =
  "https://res.cloudinary.com/dsywsrg4f/image/upload/v1664663476/salvation/bible_vunkuj.jpg";

const CrossCheck = () => (
  <svg
    viewBox="0 0 20 20"
    width={18}
    height={18}
    fill="none"
    style={{ flexShrink: 0 }}
  >
    <circle cx="10" cy="10" r="10" fill={GOLD} />
    <path
      d="M6 10.5l2.8 2.8 5.2-5.6"
      stroke="#000c66"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Welcome = () => {
  return (
    <section
      style={{ background: "#fff", position: "relative", overflow: "hidden" }}
    >
      {/* Faint watermark cross */}
      <svg
        style={{
          position: "absolute",
          right: "-60px",
          top: "50%",
          transform: "translateY(-50%)",
          opacity: 0.03,
          pointerEvents: "none",
        }}
        width={440}
        height={440}
        viewBox="0 0 200 200"
        fill={PRIMARY}
      >
        <rect x="88" y="10" width="24" height="180" rx="4" />
        <rect x="10" y="68" width="180" height="24" rx="4" />
      </svg>

      <div
        className="mx-auto px-4 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center"
        style={{ maxWidth: 1200 }}
      >
        {/* ── Left: Image with gold frame ─────────────────── */}
        <div className="hidden lg:block" style={{ position: "relative" }}>
          {/* Offset gold frame behind image */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              transform: "translate(14px, 14px)",
              border: `2px solid ${GOLD}`,
              borderRadius: 4,
            }}
          />
          <div
            style={{
              position: "relative",
              border: `3px solid ${GOLD}`,
              borderRadius: 4,
              boxShadow: `0 0 0 6px ${GOLD}22`,
              overflow: "hidden",
              lineHeight: 0,
            }}
          >
            <img
              src={IMG}
              alt="Holy Bible"
              style={{
                width: "100%",
                height: 480,
                objectFit: "cover",
                objectPosition: "center",
                display: "block",
              }}
            />
            {/* Gold corner accent top-left */}
            <div
              style={{
                position: "absolute",
                top: 14,
                left: 14,
                width: 28,
                height: 28,
                borderTop: `2px solid ${GOLD}`,
                borderLeft: `2px solid ${GOLD}`,
              }}
            />
            {/* Gold corner accent bottom-right */}
            <div
              style={{
                position: "absolute",
                bottom: 14,
                right: 14,
                width: 28,
                height: 28,
                borderBottom: `2px solid ${GOLD}`,
                borderRight: `2px solid ${GOLD}`,
              }}
            />
            {/* Subtle navy tint */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `linear-gradient(to top, ${PRIMARY}44 0%, transparent 50%)`,
              }}
            />
          </div>
        </div>

        {/* ── Right: Content ──────────────────────────────── */}
        <div>
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
            <p
              className="font-abel uppercase tracking-[0.4em] text-xs"
              style={{ color: GOLD }}
            >
              Who We Are
            </p>
            <div className="h-px w-8" style={{ background: `${GOLD}88` }} />
          </div>

          {/* Heading */}
          <h2
            className="font-aref font-bold leading-tight"
            style={{
              color: PRIMARY,
              fontSize: "clamp(1.75rem, 3.5vw, 2.8rem)",
            }}
          >
            Welcome to{" "}
            <span style={{ color: GOLD }}>CCC Salvation</span> Parish
          </h2>

          {/* Gold divider */}
          <div
            className="my-5"
            style={{
              width: 56,
              height: 3,
              background: `linear-gradient(90deg, ${GOLD}, ${GOLD}44)`,
              borderRadius: 2,
            }}
          />

          {/* Body text */}
          <p
            className="font-abel text-base leading-relaxed"
            style={{ color: "#444", maxWidth: 520 }}
          >
            CCC Salvation Parish is a unique church where God showers unique
            blessings — a church in a class of its own, ordained by the
            Almighty God to provide spiritual and physical soothing balm to
            the people of the world.
          </p>

          {/* Sub-label */}
          <p
            className="font-abel font-bold uppercase tracking-widest text-xs mt-8 mb-4"
            style={{ color: PRIMARY, letterSpacing: "0.3em" }}
          >
            You can visit us for:
          </p>

          {/* Feature items */}
          <ul className="flex flex-col gap-3">
            {welcomeData.map((item) => (
              <li
                key={item.id}
                className="flex items-center gap-3 px-4 py-3 rounded-lg"
                style={{
                  background: `${GOLD}0d`,
                  border: `1px solid ${GOLD}33`,
                }}
              >
                <CrossCheck />
                <span
                  className="font-abel text-sm font-semibold"
                  style={{ color: PRIMARY }}
                >
                  {item.text}
                </span>
              </li>
            ))}
          </ul>

          {/* Scripture footer */}
          <div
            className="mt-8 pl-4 font-abel italic text-sm leading-relaxed"
            style={{
              borderLeft: `3px solid ${GOLD}`,
              color: "#666",
            }}
          >
            "For where two or three are gathered together in my name, there
            am I in the midst of them." — Matthew 18:20
          </div>
        </div>
      </div>
    </section>
  );
};
